var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"answer-container"},[_c('question',{attrs:{"curQuestion":_vm.curQuestion,"practiceName":_vm.practiceName,"curQuestionIndex":_vm.curQuestionIndex,"qList":_vm.qList},on:{"btntopre":_vm.toPre,"btntonext":_vm.toNext}}),_vm._v(" "),_c('qList',{attrs:{"qList":_vm.qList},on:{"qListClick":_vm.qListClick}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269d563e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Analysis/Analysis.vue
// module id = null
// module chunks = 